import { Pipe, PipeTransform } from '@angular/core';
import { VehicleLayoutDictionaryService } from 'src/app/settings/service/vehicle-layout-dictionary.service';

@Pipe({
  name: 'dictionaryTranslate'
})
export class DictionaryTranslatePipe implements PipeTransform {

  constructor(private vehicleLayoutDictionaryService: VehicleLayoutDictionaryService) {
  }

  transform(value: string, sideNumber: string): string {
    if (sideNumber)
      return this.vehicleLayoutDictionaryService.getDescriptionForValueBySideNumber(sideNumber, value) || value;
    else return value;
  }

}
